import { careOfFields } from '../../../../../Helpers/AddressHelper';

export const mapCareOfFieldsForSelect = () => {
  return [
    ...careOfFields.map(x => {
      return { key: x.id, value: x.value, displayName: x.value };
    }),
  ];
};
